<template>
  <section v-if="isOpen" class="popup flex">
    <div class="popBody">
      <a class="close" @click.prevent="close">
        <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
      </a>
      <section class="popHeader"></section>
      <section class="popMain">
        <div class="fL text-center">{{ $t('alert', '提示') }}</div>
        <div class="icon"></div>
        <span class="">{{ $t('leave-confirm', '您即將離開 App 前往外部連結，請問是否繼續？') }}</span>
      </section>
      <section class="popFooter flex">
        <a
          class="button bg-transparent text-black border border-primary flex-1 submit rounded"
          @click.prevent="close"
          >{{ $t('back', '返回') }}</a
        >
        <a class="button flex-1 submit rounded" @click.prevent="goOut"
          ><span class="fM">{{ $t('confirm', '確認') }}</span></a
        >
      </section>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'LeaveDialog',
    props: {
      show: {
        type: Boolean,
        default: false,
        required: true
      },
      url: {
        type: String,
        default: '',
        required: true
      }
    },
    emits: ['close'],
    data() {
      return {
        isOpen: false
      }
    },
    watch: {
      show(val) {
        this.isOpen = val;
      }
    },
    methods: {
      close() {
        this.isOpen = false;
        this.$emit('close');
      },
      goOut() {
        this.close();

        if (this.url) window.open(this.url, '_blank', 'noopener,noreferrer');
      }
    }
  };
</script>
